'use client'

import { type ComponentProps, lazy } from 'react'

// The server footer has its own Suspense boundary. Preserve its SSR content
// without adding its behavior to the header's initial script requests.
const SubscribeCta = lazy(() => import('./subscribe-cta').then((module) => ({ default: module.SubscribeCta })))

export const SubscribeCtaLazy = (props: ComponentProps<typeof SubscribeCta>) => <SubscribeCta {...props} />
